import { Translation } from "../translation.model";

export class AddTrialNotificationTemplate {
  public trialId: string;
  public diaryFormId: string;
  public notificationType: number;
  public rule: string;
  public emailNotificationEnabled: boolean;
  public appNotificationEnabled: boolean;
  public mandatoryNotification: boolean;
  public translations: Translation[] = [];
  public offsetUnit: number;
  public offsetAmount: number;
  public afterEvent: boolean;
  public trigger: number;
  public ediaryMissedEntryCount: number;
  public expression: string;
  public expressionOffsetUnit: number;
  public expressionOffsetAmount: number;
  public logicalOperator: number;

  constructor(init?: Partial<AddTrialNotificationTemplate>) {
    Object.assign(this, init);
  }
}
